import { TextMultiValuedList } from '../../TextMultiValuedList'

import { ListItem } from './ListItem'
import { filter } from './MessageFolders.utils'
import { More } from './More'
import { MoreItem } from './MoreItem'

import * as styles from './MessageFolders.module.css'

function MessageFolders({
  className = styles.MessageFolders,
  items,
  scrollRef,
}) {
  return (
    <div className={className}>
      <TextMultiValuedList
        Item={ListItem}
        More={More}
        MoreItem={MoreItem}
        filter={filter}
        items={items}
        moreProps={{ containerRef: scrollRef }}
      />
    </div>
  )
}

export default MessageFolders
